
import React, {Component} from "react";
import {useState, useEffect,useContext} from 'react'
import useFetch from '../../APIs/SpotifyGetArtistAlbums.js';
import LoadingSkeleton from '../../LoadingSkeletons/AlbumCard.js';
import AlbumCard from '../../Cards/SpotifyArtistAlbumCard.js';
import {Link} from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";


// import required modules
import { Navigation } from "swiper/modules";
const Albums = (props) => {

    const [data, setData] = useState(null)
    const [request, setRequest] = useState(null)
    const {data:FetchedData,isLoading, error} = useFetch(request)

    const send_request =()=>{
        setData(null)
        setRequest({
            "search_string":props.filters.search_string,
            "genre": "",
            "album_id": "",
            "user_id":props.filters.user_id,
            "genre": props.filters.genre,
            "sort": props.filters.sort===""?"newest":props.filters.sort,
            "page":1,
        })
    }
  
    useEffect(()=>{
        setData(null)
        send_request()
    },[props.filters])


    useEffect(()=>{
        if(FetchedData && FetchedData.total>0){
            setData(FetchedData)
            props.setTotalAlbums(FetchedData.total)
        }
    },[FetchedData])



    return (
        <>
        {data &&(
        <>
         <section>
                <div className="row">
                    <div className="col-12 col-lg-12">
                        <div className="htitle">
                            <div className="lft"><p>ALBUMS</p></div>
                            {data.total>9 &&(
                                <div className="rgt"><p><Link to={"/spotify/profile/browse/"+props.filters.user_id+"?group=albums"}>See more</Link></p></div>
                            )}
                        </div>
                        {props.innerWidth<992 &&(
                            <div className="vertical-container">
                                {data.items.slice(0,10).map((album,index)=>( 
                                    <AlbumCard data={album} key={index}/>
                                ))}
                            </div>
                        )}
                        {props.innerWidth>992 &&(
                            <Swiper
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                    640: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },
                                    992: {
                                        slidesPerView: 5,
                                        spaceBetween: 20,
                                    },
                                    1600: {
                                        slidesPerView: 7,
                                        spaceBetween: 30,
                                    },
                                }}
                                className="mySwiper"
                            >
                                    {data.items.slice(0,10).map((album,index)=>( 
                                        <SwiperSlide key={index}><AlbumCard data={album} key={index}/></SwiperSlide>
                                ))}
                                
                            </Swiper>           
                        )}        
                    </div>
                </div>
            </section>  
        </>
        )}
         {(isLoading) &&(
            <>
                <section>
                    <div className="row">
                        <div className="col-12 col-lg-12">

                            <div className="htitle">
                                <div className="lft"><p>ALBUMS</p></div>
                            </div>
                            {props.innerWidth<992 &&(
                                <div className="vertical-container">
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                    <LoadingSkeleton/>
                                </div>
                            )}
                            {props.innerWidth>992 &&(
                                <Swiper
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                        640: {
                                            slidesPerView: 2,
                                            spaceBetween: 10,
                                        },
                                        992: {
                                            slidesPerView: 5,
                                            spaceBetween: 20,
                                        },
                                        1600: {
                                            slidesPerView: 7,
                                            spaceBetween: 30,
                                        },
                                    }}
                                    className="mySwiper"
                                >
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    <SwiperSlide ><LoadingSkeleton/></SwiperSlide>
                                    
                                </Swiper>           
                            )}
                        </div>
                    </div>
                </section>  
            </>
        )}
        </>
    )
}

export default Albums
